import type { QueryParams } from './types'

export const CACHE_TIMES = {
  STALE_DEFAULT: 0,
  STALE_FILTERED: 0,
  STALE_STATIC: 0,
  STALE_DETAIL: 0,
  STALE_LIST: 0,
  STALE_REALTIME: 0,
  GC_TIME: 0,
  GC_TIME_STATIC: 0,
}

export function isDefaultQuery(params?: QueryParams): boolean {
  if (!params) return true
  const { page, limit: _limit, sortBy: _sortBy, sortOrder: _sortOrder, status: _status, ...filters } = params
  const isFirstPage = !page || page === 1
  const hasFilters = Object.values(filters).some((v) => v !== undefined && v !== null && v !== '')
  return isFirstPage && !hasFilters
}

export function getStaleTime(params?: QueryParams): number {
  return isDefaultQuery(params) ? CACHE_TIMES.STALE_DEFAULT : CACHE_TIMES.STALE_FILTERED
}
